var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('searchForm',{ref:"MyTerm",on:{"show":_vm.show,"handleSubmit":_vm.handleSubmit}}),_c('Table',{attrs:{"columns":_vm.columns1,"data":_vm.data,"height":_vm.tableHeight,"size":"small"}}),_c('MyPage',{ref:"sonPage",attrs:{"param":_vm.SelectParam,"url":_vm.getUseRateInfoUrl},on:{"listData":_vm.getDeviceData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }